import { EntityWithStatusService } from './EntityWithStatusService';
import { IPPObjective, IEntityChildren, IEntityDescription1 } from '../types';
import { EntityStatus } from '../refData/EntityStatus';
import { AppGlobals } from '../AppGlobals';

export class PPObjectiveService extends EntityWithStatusService<IPPObjective> {
    //public readonly parentEntities = ['ManagedByL2', 'ManagedByL3'];
    protected childrenEntities = ['PPObjectiveVisions'];

    constructor() {
        super(`/PPObjectives`);
    }

    public readAllForLookup(includeClosed?: boolean): Promise<IPPObjective[]> {
        return this.readAll(
            `?$select=ID,Title`
            + `&$orderby=Title&$filter=CustomerID eq ${AppGlobals.CustomerID}`
            + (includeClosed ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
        );
    }

    public readAllForList(includeClosed?: boolean, visionID?: number): Promise<IPPObjective[]> {
        return this.readAll(
            `?$select=ID,Title,OwnerTypeID`
            + `&$orderby=Title`
            + `&$expand=OwnerL1($select=Title),OwnerL2($select=Title),OwnerL3($select=Title),EntityStatus($select=Title),PPObjectiveVisions($expand=Vision($select=ID,Title)),Portfolios($select=ID)`
            + `&$filter=CustomerID eq ${AppGlobals.CustomerID}`
            + (includeClosed ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
            + (visionID ? ` and PPObjectiveVisions/any(v: v/VisionID eq ${visionID})` : ``)
        );
    }


    // public async readForView(portfolioID: number): Promise<IPortfolio> {
    //     return this.read(
    //         portfolioID,
    //         false,
    //         false,
    //         [
    //             'ParentPortfolio($select=Title)',
    //             'OwnerL1($select=Title)',
    //             'OwnerL2($select=Title)',
    //             'OwnerL3($select=Title)',
    //             'ManagedByL2($select=Title)',
    //             'ManagedByL3($select=Title)',
    //             'PortfolioManagerUser($select=Title,EmailAddress)',
    //             'Contributors($expand=ContributorUser($select=Title,EmailAddress))',
    //             'CustomFields($expand=CustomFieldDfn($select=Title))'
    //         ]
    //     );
    // }

    public async readTitleForObjective(entityPlural: string, entitySingular: string, objectiveID: number): Promise<IEntityDescription1> {
        const entityDescription1: IEntityDescription1 = {
            Description1ForList: '',
            Description1ForForm: '',
            DescriptionLine1: '',
            DescriptionLine2: '',
        };
        const res = await this.readAll(`?$filter=ID eq ${objectiveID}&$select=Title`);
        if (res.length > 0) {
            entityDescription1.DescriptionLine1 = `${entityPlural} for objective`;
            entityDescription1.DescriptionLine2 = res[0].Title;
            entityDescription1.Description1ForList = `${entityPlural} for objective <span style='font-style: italic'>${res[0].Title}</span>`;
            entityDescription1.Description1ForForm = `${entitySingular} for objective <span style='font-style: italic'>${res[0].Title}</span>`;
        }

        return entityDescription1;
    }

    public async entityChildren(id: number): Promise<IEntityChildren[]> {
        //TODO with actual children
        return [];
    }

    public async countObjectives(): Promise<number> {
        return (await this.readAll(`?$select=ID&$filter=EntityStatusID eq ${EntityStatus.Open}`))?.length;
    }
}